module.exports = __webpack_public_path__ + "img/DiNapoli-icon1.386107a9.svg";